var _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBesooktBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 99,
    viewBox: "0 0 170 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5455_11288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 170,
    height: 99
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.52343C0 3.20973 2.68629 0.523438 6 0.523438H164C167.314 0.523438 170 3.20973 170 6.52344V92.5234C170 95.8371 167.314 98.5234 164 98.5234H6C2.68629 98.5234 0 95.8371 0 92.5234V6.52343Z",
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5455_11288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.325 38.7317C141.522 35.0465 146.736 35.0465 147.933 38.7317L152.717 53.4535C153.252 55.1016 154.788 56.2174 156.521 56.2174H172C175.875 56.2174 177.486 61.1759 174.351 63.4535L161.828 72.5521C160.426 73.5707 159.84 75.3761 160.375 77.0242L165.159 91.7461C166.356 95.4313 162.138 98.4958 159.003 96.2182L146.48 87.1196C145.078 86.101 143.18 86.101 141.778 87.1196L129.255 96.2182C126.12 98.4958 121.902 95.4313 123.099 91.746L127.883 77.0242C128.418 75.3761 127.832 73.5707 126.43 72.5521L113.907 63.4535C110.772 61.1759 112.383 56.2174 116.258 56.2174H131.737C133.47 56.2174 135.006 55.1016 135.541 53.4535L140.325 38.7317Z",
    fill: "url(#paint0_linear_5455_11288)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.032 20.1455L145.032 28.6979",
    stroke: "#DDEBF6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.492 22.5459L136.768 29.9525",
    stroke: "#DDEBF6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.231 33.0737L132.492 35.2873",
    stroke: "#DDEBF6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5455_11288",
    x1: 144.129,
    y1: 27.0235,
    x2: 181.771,
    y2: 107.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF5FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesooktBoardPage);
export default __webpack_public_path__ + "static/media/besookt-board-page.290f695ebaefe27c0503bd52710e9c21.svg";
export { ForwardRef as ReactComponent };